import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from "components/ui/card";
import React from "react";
import useDarkMode from "use-dark-mode";
import { ReactQueryErrorWrapper } from "components/shared/react-query-error-wrapper";
import { UsageGraphProps } from "./types";
import { useChartConfig } from "./use-chart-config";

export const UsageGraph: React.FC<UsageGraphProps> = (props) => {
  const darkMode = useDarkMode(false);
  const chartRef = useChartConfig(props, darkMode.value);

  return (
    <Card className="flex flex-col">
      <CardHeader>
        <CardTitle>Credit Usage</CardTitle>
        {props.subheader && (
          <CardDescription>{props.subheader}</CardDescription>
        )}
      </CardHeader>
      <CardContent className="h-full w-full">
        <ReactQueryErrorWrapper queries={[props.usageQuery]} mutations={[]} />
        {props.isSuccess && (
          <div ref={chartRef} style={{ height: 500, width: "100%" }} />
        )}
      </CardContent>
    </Card>
  );
};
